import { LOAD_USER_ADDRESS_BOOK_REQUEST, LOAD_USER_ADDRESS_BOOK_SUCCESS, LOAD_USER_ADDRESS_BOOK_ERROR } from '../types';
import { useHelper } from '../helpers';
export const loadUserAddressBookRequest = () => ({
  type: LOAD_USER_ADDRESS_BOOK_REQUEST
});
export const loadUserAddressBookSuccess = data => ({
  type: LOAD_USER_ADDRESS_BOOK_SUCCESS,
  payload: {
    data
  }
});
export const loadUserAddressBookError = error => ({
  type: LOAD_USER_ADDRESS_BOOK_ERROR,
  payload: error,
  error: true
});
export const loadUserAddressBook = () => async (dispatch, getState, _ref) => {
  let {
    chord
  } = _ref;
  const {
    withAuth
  } = useHelper(dispatch, getState);
  dispatch(loadUserAddressBookRequest());
  try {
    const {
      user
    } = getState();
    const userId = user.data.id;
    const response = await withAuth(chord.oms.getUserAddressBook)(userId);
    dispatch(loadUserAddressBookSuccess(response));
    return response;
  } catch (error) {
    dispatch(loadUserAddressBookError(error));
    throw error;
  }
};